import Vue from 'vue'
import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {IOrderPromotion} from "@/model/Order/orderInterfaces";
import {IPromotion} from "@/model/Promotions/IPromotion";
import responseHandler from "@/plugins/errorHandling";

export interface ICreateCouponRequest {
  note?: string,
  value: number|null,
  value_type: string|null,
  min_total?: number|null,
}

export interface IUserPermission {
  user_id: number,
  permission: number,
  target_id: number,
  email: string,
  granted_by: number,
  granted_by_name: number,
  created_at: string,
}

interface UserPromotionsState {
  usersUsedPromotions: IOrderPromotion[];
  usersCoupons: IPromotion[];
  errors: IErrors;
}

const state: UserPromotionsState = {
  usersUsedPromotions: [],
  usersCoupons: [],
  errors: {},
};

const getters: GetterTree<UserPromotionsState, RootState> = {
  usersUsedPromotions: (state): IOrderPromotion[] => state.usersUsedPromotions,
  usersCoupons: (state): IPromotion[] => state.usersCoupons,
  errors: (state) => state.errors,
};

const actions: ActionTree<UserPromotionsState, RootState> = {
  fetchUsedPromotions: ({commit}, userId): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'users/' + userId + '/promotions/used',
    }),
    commit,
    'usedPromotionsLoaded'
  ),
  fetchCoupons: ({commit}, userId): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'users/' + userId + '/promotions/coupons',
    }),
    commit,
    'couponsLoaded'
  ),
  createCoupon: ({commit}, params: {userId: number, couponRequest: ICreateCouponRequest}): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'users/' + params.userId + '/coupon',
      method: 'POST',
      data: params.couponRequest
    // }),
    }),
    commit,
    'couponCreated',
    null,
    false
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  }
};

const mutations: MutationTree<UserPromotionsState> = {
  usedPromotionsLoaded(state: UserPromotionsState, payload: IOrderPromotion[]) {
    state.usersUsedPromotions = payload;
  },
  couponsLoaded(state: UserPromotionsState, payload: IPromotion[]) {
    state.usersCoupons = payload;
  },
  couponCreated(state: UserPromotionsState, payload: IPromotion) {
    state.usersCoupons.push(payload);
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanError(state, index: string) {
    Vue.delete(state.errors, index);
  }
};

const namespaced: boolean = true;

export const usersPromotionModule: Module<UserPromotionsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
